import { ReportStatus } from 'dashboard/models/report';
import { ReportCustomListAttributes } from 'dashboard/models/report/custom-list';
import {
  ReportRunCustomList,
  ReportRunMatchStatus,
  ReportRunRelationships,
} from 'dashboard/models/report-run';
import { ApiModel } from 'lib/interfaces/api';

const createdAt = '2023-01-01T00:00:00.000Z';
const completedAt = '2023-01-01T00:01:00.000Z';

export function createPreviewReportRunCustomList(
  attributes?: Partial<ReportCustomListAttributes>,
  relationships?: Partial<ReportRunRelationships>,
  id?: string,
): ReportRunCustomList {
  return {
    id: id || 'rprcl_123',
    type: ApiModel.ReportRunCustomList,
    attributes: {
      status: ReportStatus.Ready,
      'created-at': createdAt,
      'completed-at': completedAt,
      'primary-input': 'Joe Doe',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'scheduled-at': null,
      'hit-entries': [],
      'dismissed-entries': [],
      query: {
        'name-first': 'Joe',
        'name-last': 'Doe',
      },
      result: ReportRunMatchStatus.NoMatch,
      ...attributes,
    },
    relationships: {
      'report-template-version': {
        data: {
          id: 'rptv_0001',
          type: ApiModel.ReportTemplateVersionCustomList,
        },
      },
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'report-template': null,
      report: {
        data: {
          id: 'rep_0001',
          type: ApiModel.ReportCustomList,
        },
      },
      ...relationships,
    },
  };
}
